// Hooks (@tanstack/react-query) imports
import { useMutation } from "@tanstack/react-query";

// Configs imports
import api from "../../app/api";

// Custom types imports
import { ApiErrorResponse } from "apisauce";
import { Person } from "./types";

interface paramsType {
  username: string;
  notificationID: string | number;
}

export function usePersonByUsernameMutation(
  onSuccessMutation?: (data: any, variables: paramsType) => void,
  onErrorMutation?: (err: ApiErrorResponse<any>, variables: paramsType) => void
) {
  async function personByUsername(params: paramsType): Promise<Person> {
    const response = await api.get<Person>(
      `admin/persons/byusername/${params.username}`
    );

    if (!response.ok || !response.data) {
      throw response;
    }

    return response.data;
  }

  return useMutation({
    mutationFn: personByUsername,
    onSuccess: onSuccessMutation,
    onError: onErrorMutation,
  });
}
